/**
 * Slugifies a string by replacing all non-alphanumeric characters with underscores and lowercasing the result.
 */
export const slugify = (text: string): string => text.replace(/[^a-z0-9]/gi, '_').toLowerCase();
